module.exports = __webpack_public_path__ + "img/share-blue.ff4cd594.svg";